import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Hidden from '@material-ui/core/Hidden';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import { HappinessMeter } from 'aurora-section-components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { isFeedbackProvided, getPropertType, keyEmptyCheck } from 'aurora-utils/utils';
import messages from 'aurora-translations';
import ADGMImage from '../../ADGMImage';
import styles from './styles';

function Layout(props) {
  const {
    classes,
    history,
    type,
    title,
    subTitle,
    data,
    downloadhandler,
    isShowPdfButton,
    intl,
    downloadPaymenthandler,
    application,
  } = props;
  const [propertyObject, setPropertyObject] = useState('');
  let lang = localStorage.getItem('lang');
  useEffect(() => {
    lang = localStorage.getItem('lang');
    if (lang === 'en') {
      setPropertyObject(data?.en);
    } else {
      setPropertyObject(data?.ar);
    }
  }, [data]);

  const goToPropertyHandler = () => {
    history.push('/app/properties?type=ownership');
  };

  const renderIcon = typeIcon => {
    if (typeIcon === 'rejection') {
      return 'contractImage.svg';
    }
    if (typeIcon === 'termination') {
      return 'errorIcon.svg';
    }
    if (typeIcon === 'dmtPayment') {
      return 'DMTPaymentuccess.svg';
    }
    return 'successIcon.svg';
  };

  const renderClass = typeClass => {
    if (typeClass === 'rejection') {
      return classes.textHolder;
    }
    if (typeClass === 'termination') {
      return classes.textHolderTermination;
    }
    if (typeClass === 'dmtPayment') {
      return classes.textHolderApproval;
    }
    return classes.textHolderApproval;
  };

  const getPropertyTitle = prop => {
    const propertyType = getPropertType(prop?.propertyType);
    let propertyTitle = null;
    if (propertyType === 'Land') {
      const subTitleArr = [];
      prop?.plotNumber && subTitleArr.push(`${intl.formatMessage({ ...messages.plot_number })}: ${prop?.plotNumber}`);
      prop?.district && subTitleArr.push(`${intl.formatMessage({ ...messages.district })}: ${prop?.district}`);
      prop?.community && subTitleArr.push(`${intl.formatMessage({ ...messages.community })}: ${prop?.community}`);
      propertyTitle = subTitleArr.join(', ');
    }
    if (propertyType === 'Unit') {
      const subTitleArr = [];
      prop?.unitNumber && subTitleArr.push(`${intl.formatMessage({ ...messages.unit_number })}: ${prop?.unitNumber}`);
      (prop?.buildingName || prop?.buildingNumber) &&
        subTitleArr.push(
          `${intl.formatMessage({ ...messages.building_name })}: ${prop?.buildingName || prop?.buildingNumber}`,
        );
      prop?.floorNumber &&
        subTitleArr.push(`${intl.formatMessage({ ...messages.floor_number })}: ${prop?.floorNumber}`);
      propertyTitle = subTitleArr.join(', ');
    }
    return { propertyTitle };
  };
  const isFeedbackGiven = isFeedbackProvided(
    application?.initiatorUserId,
    application?.happinessMeter,
    application?.applicationStatus,
  );
  return (
    <Container className={classes.container}>
      {!isFeedbackGiven && (
        <HappinessMeter
          applicationNumber={application?.applicationNumber}
          applicationId={application?.id}
          applicationType={application?.applicationType}
        />
      )}
      <Hidden smUp>
        <div className={classes.mobileTitlehead}>
          <div>
            <FormattedMessage {...messages.success} />
          </div>
        </div>
      </Hidden>
      <Grid container spacing={3} justify='center'>
        <Grid item xs={12} md={8}>
          <div className={classes.contentArea}>
            <div className={classes.bannerArea}>
              <Hidden smUp>
                <div className={classes.textHolder}>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </div>
              </Hidden>
              <div>
                <ADGMImage name={renderIcon(type)} alt='success img' />
              </div>
              <div className={renderClass(type)}>
                <Hidden smDown>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </Hidden>
                <Typography variant='body1'>{subTitle}</Typography>
                {isShowPdfButton === true || typeof downloadPaymenthandler === 'function' ? (
                  <div className={classes.btnContainer}>
                    {isShowPdfButton === true && (
                      <Button
                        variant='outlined'
                        className={classes.btnADGMOutlineBlack}
                        size='large'
                        onClick={downloadhandler}
                      >
                        <ADGMImage
                          name='Download-Icon.svg'
                          alt='downloadIcon'
                          className={classes.btnImage}
                          width='16px'
                          height='16px'
                        />{' '}
                        <FormattedMessage {...messages.download_certificate} />
                      </Button>
                    )}
                    {typeof downloadPaymenthandler === 'function' && (
                      <Button
                        variant='outlined'
                        className={classes.btnADGMOutlineBlack}
                        size='large'
                        onClick={downloadPaymenthandler}
                      >
                        <ADGMImage
                          name='Download-Icon.svg'
                          alt='downloadIcon'
                          className={classes.btnImage}
                          width='16px'
                          height='16px'
                        />{' '}
                        <FormattedMessage {...messages.download_payment_receipt} />
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <Typography align='right' className={classes.applicationIdStyle}>
              <FormattedMessage {...messages.Application_ID} /> : <strong>{propertyObject?.applicationNumber}</strong>
            </Typography>
            <div className={classes.detailItemHolder}>
              {propertyObject?.title && (
                <div className={classes.detailItem}>
                  <div className={classes.text}>
                    <Typography variant='body1'>
                      <FormattedMessage {...messages.property} />
                    </Typography>
                    <Typography variant='h6' component='h2'>
                      {
                        getPropertyTitle(lang === 'en' ? propertyObject?.property?.en : propertyObject?.property?.ar)
                          ?.propertyTitle
                      }
                    </Typography>
                  </div>
                  <Chip
                    label={keyEmptyCheck(propertyObject?.type)}
                    color='primary'
                    className={classNames(classes.darkgray, classes.uniChip)}
                  />
                </div>
              )}
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.OWNER} />
                  </Typography>
                  <Typography variant='h6' component='h2'>
                    {propertyObject?.ownerName}
                  </Typography>
                </div>
              </div>
            </div>
            <div className={classes.fixedonMobileHolder}>
              <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                <FormattedMessage {...messages.go_to_applications} />
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  isShowTranctions: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
  isShowCalendarButton: PropTypes.bool.isRequired,
  isSellPurhcaseSuccess: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  downloadPaymenthandler: PropTypes.func.isRequired,
  application: PropTypes.object,
};
Layout.defaultProps = {
  application: {},
};

export default withStyles(styles)(injectIntl(Layout));
